import _defineProperty from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { unit } from '@ant-design/cssinjs';
var genPaginationStyle = function genPaginationStyle(token) {
  var _$concat;
  var componentCls = token.componentCls,
    antCls = token.antCls,
    margin = token.margin;
  return _defineProperty({}, "".concat(componentCls, "-wrapper"), (_$concat = {}, _defineProperty(_$concat, "".concat(componentCls, "-pagination").concat(antCls, "-pagination"), {
    margin: "".concat(unit(margin), " 0")
  }), _defineProperty(_$concat, "".concat(componentCls, "-pagination"), {
    display: 'flex',
    flexWrap: 'wrap',
    rowGap: token.paddingXS,
    '> *': {
      flex: 'none'
    },
    '&-left': {
      justifyContent: 'flex-start'
    },
    '&-center': {
      justifyContent: 'center'
    },
    '&-right': {
      justifyContent: 'flex-end'
    }
  }), _$concat));
};
export default genPaginationStyle;